import { BreakpointObserver } from '@angular/cdk/layout';

export const XSMALL_SCREEN = 'xs';
export const SMALL_SCREEN = 'sm';
export const MEDIUM_SCREEN = 'md';
export const LARGE_SCREEN = 'lg';
export const XLARGE_SCREEN = 'xl';

export const MEDIA_SIZES = [XSMALL_SCREEN, SMALL_SCREEN, MEDIUM_SCREEN, LARGE_SCREEN, XLARGE_SCREEN];

export function matchesScreenSizeMin(size: string, breakpointObserver: BreakpointObserver): boolean {
  const isXs = isXSmallScreen(breakpointObserver);
  const isSm = isSmallScreen(breakpointObserver);
  const isMd = isMediumScreen(breakpointObserver);
  const isLg = isLargeScreen(breakpointObserver);
  const isXl = isXLargeScreen(breakpointObserver);

  let matchesScreenSize = false;

  switch (size) {
    case XSMALL_SCREEN:
      matchesScreenSize = isXs || isSm || isMd || isLg || isXl;
      break;
    case SMALL_SCREEN:
      matchesScreenSize = isSm || isMd || isLg || isXl;
      break;
    case MEDIUM_SCREEN:
      matchesScreenSize = isMd || isLg || isXl;
      break;
    case XLARGE_SCREEN:
      matchesScreenSize = isXl;
      break;
    case LARGE_SCREEN:
    default:
      matchesScreenSize = isLg || isXl;
  }

  return matchesScreenSize;
}

export function isXSmallScreen(breakpointObserver: BreakpointObserver): boolean {
  return isMediaScreen('(max-width: 599px)', breakpointObserver);
}

export function isSmallScreen(breakpointObserver: BreakpointObserver): boolean {
  return isMediaScreen('(min-width: 600px)', breakpointObserver);
}

export function isMediumScreen(breakpointObserver: BreakpointObserver): boolean {
  return isMediaScreen('(min-width: 840px)', breakpointObserver);
}

export function isLargeScreen(breakpointObserver: BreakpointObserver): boolean {
  return isMediaScreen('(min-width: 1024px)', breakpointObserver);
}

export function isXLargeScreen(breakpointObserver: BreakpointObserver): boolean {
  return isMediaScreen('(min-width: 1280px)', breakpointObserver);
}

function isMediaScreen(mediaQuery: string, breakpointObserver: BreakpointObserver): boolean {
  return breakpointObserver.isMatched(mediaQuery);
}
